export default {
    title: 'ទំព័រនេះស្ថិតនៅក្រោមការថែទាំ',
    subtitle: 'យើងនឹងត្រលប់មកវិញឆាប់ៗនេះ',
    dont_show_again: 'កុំបង្ហាញម្តងទៀត',
    until: 'រហូតដល់',
    system_maintenance_scheduled_on: 'តំហែទាំប្រព័ន្ធគ្រោងនឺងធ្វើនៅថ្ងៃទី',
};
